import React, { ReactNode } from 'react'
import { AnchorsOfFormsWrappers } from '@constants/forms'
import { PartnerForm } from '@shared/components/forms/partner'
import { Section } from '@shared/components/section'

import styles from './style.module.scss'

interface Props {
	title?: ReactNode
	summary?: string[]
	btnText?: string
}

const defaultTitle = <>Зарабатывайте вместе с&nbsp;нами</>
const defaultSummary = [
	'Оставьте заявку.',
	'Подключитесь к программе за 5 минут.',
	'Рассказывайте отказникам о доступных кредитных программах в Credit.Club.',
]

export const View = ({ title = defaultTitle, summary = defaultSummary, btnText }: Props) => (
	<Section id={AnchorsOfFormsWrappers.partner} fullWidth className={styles.fluidWrapper}>
		<Section className={styles.wrapper}>
			<div className={styles.summary}>
				<h2 className={styles.title}>{title}</h2>
				<div className={styles.summaryContent}>
					{summary.map((s, idx) => (
						<div key={idx} className={styles.summaryItem}>
							<span className={styles.summaryNumber}>{idx + 1}</span>{' '}
							<span className={styles.summaryText}>{s}</span>
						</div>
					))}
				</div>
			</div>
			<div className={styles.formWrapper}>
				<PartnerForm btnText={btnText} />
			</div>
		</Section>
	</Section>
)
